import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GenerateSurveyPreviewLinkRPC } from "./generateSurveyPreviewLinkRPC";

export class GenerateSurveyPreviewLinkRPCClientImpl extends GenerateSurveyPreviewLinkRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GenerateSurveyPreviewLinkRPC.Request): Promise<LeoRPCResult<GenerateSurveyPreviewLinkRPC.Response, GenerateSurveyPreviewLinkRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/GenerateSurveyPreviewLink",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GenerateSurveyPreviewLinkRPC.ResponseDTO,
      GenerateSurveyPreviewLinkRPC.Errors.ErrorsDTO,
      GenerateSurveyPreviewLinkRPC.Response,
      GenerateSurveyPreviewLinkRPC.Errors.Errors
    >(
      response,
      "survey/GenerateSurveyPreviewLink",
      GenerateSurveyPreviewLinkRPC.Response.fromDTO,
      GenerateSurveyPreviewLinkRPC.Errors.fromDTO
    );
  }
}
